import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { cn } from '../utils/cn';

const HighValueIntent = ({ keywords }) => {
  if (!keywords || keywords.length === 0) return null;

  return (
    <div className="bg-white dark:bg-slate-900 rounded-2xl sm:rounded-3xl border border-slate-200 dark:border-slate-800 p-6 sm:p-8 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-yellow-100 dark:bg-yellow-900/30 text-yellow-600 dark:text-yellow-400 rounded-xl">
            <SafeIcon icon={FiIcons.FiTrendingUp} className="w-5 h-5" />
          </div>
          <div>
            <h3 className="text-[11px] sm:text-sm font-black uppercase tracking-widest text-slate-800 dark:text-slate-200">High-Value Intent Engine</h3>
            <p className="text-[9px] sm:text-[10px] text-slate-400 font-bold uppercase tracking-wider">Transactional & Commercial Opportunities</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {keywords.map((kw, i) => (
          <div key={i} className="group relative p-4 bg-slate-50 dark:bg-slate-800/40 rounded-xl sm:rounded-2xl border border-slate-100 dark:border-slate-700/50 hover:border-yellow-300 dark:hover:border-yellow-500/30 transition-all">
            <div className="flex justify-between items-start mb-3">
              <span className={cn(
                "text-[8px] sm:text-[9px] font-black px-2 py-0.5 rounded uppercase tracking-wider",
                kw.intent === 'Transactional' ? "bg-rose-100 text-rose-600" : "bg-yellow-100 text-yellow-700"
              )}>
                {kw.intent}
              </span>
              <div className="flex items-center gap-1.5 text-[10px] sm:text-xs font-black text-slate-900 dark:text-white">
                <SafeIcon icon={FiIcons.FiBarChart2} className="w-3.5 h-3.5 text-yellow-500" />
                {kw.volume.toLocaleString()}
              </div>
            </div>
            <h4 className="text-xs sm:text-sm font-black text-slate-900 dark:text-white capitalize truncate" title={kw.keyword}>
              {kw.keyword}
            </h4>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HighValueIntent;